import { WithContext as ReactTags } from 'react-tag-input';
import React from 'react'

import styles from './style.css'

class Tags extends React.Component {
    render() {
        return <ReactTags
            classNames={{
                tags: `${styles.Tags}`,
                tag: styles.Tag,
                tagInputField: styles.TagInputField,
                selected: '',
                remove: styles.RemoveTag
            }}
            autofocus={false}
            {...this.props}
        />
    }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/component/Tags/index.js